import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { InputDate } from "src/components/InputDate";
import {
  EvolutiveCrossButton,
  evolutiveCrossButtonStyles,
} from "../Button/index.js";

import * as Ui from "./styles.js";

function DateFilter({ handleOnFilter, handleOnCancel, ...props }, ref) {
  const {
    filterInterval: { initialDate: init, endDate: end },
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [initialDate, setInitialDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useImperativeHandle(ref, () => ({
    changeVisibility: (newState) => {
      setIsOpen(newState);
    },
  }));

  const handleFilter = useCallback(() => {

    if (handleOnFilter) handleOnFilter(initialDate, endDate);
  }, [handleOnFilter, initialDate, endDate]);

  const handleCancel = useCallback(() => {
    if (handleOnCancel) handleOnCancel();
  }, [handleOnCancel]);

  const handleSetInitialDate = useCallback((date) => {
    setInitialDate(date);
  }, []);

  const handleSetEndDate = useCallback((date) => {
    setEndDate(date);
  }, []);

  return (
    isOpen && (
      <Ui.Container isOpen={isOpen}>
        <Ui.Body>
          <p>Escolha o período que deseja:</p>
          <Ui.InputsWrapper>
            <Ui.CalendarContainer>
              <InputDate
                placeholder="Data Inicial"
                inputName="pesquisaDataInicio"
                onChangeDate={handleSetInitialDate}
                value={init}
              />
              <Ui.CalendarIcon className={"calendar-icon"} />
            </Ui.CalendarContainer>

            <Ui.CalendarContainer>
              <InputDate
                placeholder="Data Final"
                inputName="pesquisaDataFim"
                onChangeDate={handleSetEndDate}
                value={end}
              />
              <Ui.CalendarIcon className={"calendar-icon"} />
            </Ui.CalendarContainer>
          </Ui.InputsWrapper>
        </Ui.Body>
        <Ui.ButtonsWrapper>
          <EvolutiveCrossButton
            fillStyle={evolutiveCrossButtonStyles.outlined}
            type="button"
            title={"FECHAR"}
            clear
            className="cancelDateFilter"
            onClick={handleCancel}
          />
          <Ui.FilterButton
            fillStyle={evolutiveCrossButtonStyles.filled}
            type="button"
            title={"FILTRAR"}
            clear
            className="finishDateFilter"
            onClick={handleFilter}
          />
        </Ui.ButtonsWrapper>
      </Ui.Container>
    )
  );
}

export default forwardRef(DateFilter);
